import { _toReference } from "@common/helpers/utils";
import { BaseModel } from "./common.model";

export interface OrganizationModel  extends BaseModel {
  name : string;
}

export namespace OrganizationModel{
  export type Ref = Pick<OrganizationModel, 'id' | 'name' >
  export const genRef = (_object: OrganizationModel) => _toReference(['id', 'name'], _object);
}